import {useId} from 'react';

import {AppButton} from '@/components/Button';
import CloseButton from '@/components/CloseButton/CloseButton';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {StickyPageLayout} from '@/components/Layout';
import PopupResponsive from '@/components/Popup/PopupResponsive';
import appContent from '@/services/content/appContent';

const UsbConnectionRequiredPopup = ({onClose, onButtonClick}) => {
    const {icon, title, usbInstructionText, desktopUpdateText, okButton} =
        appContent.getUpdateFirmwareUsbConnectionRequiredPopupContent();
    const headerId = useId();

    return (
        <PopupResponsive
            onClose={onClose}
            className='z-[21] flex flex-col bg-romance ml:w-full ml:max-w-[494px] ml:rounded-xl ml:p-8 ml:pt-19 ml:text-center'
            aria-labelledby={headerId}
        >
            <StickyPageLayout
                contentClassName='flex flex-1 flex-col items-center justify-center p-8'
                desktopContentClassName='flex flex-col items-center'
                desktopFooterClassName='flex flex-col items-center'
                headerOptions={{
                    endIcon: <CloseButton onClick={onClose} />,
                }}
                footer={
                    <AppButton
                        primary
                        light
                        className='mt-0 ml:mt-10 ml:min-w-78'
                        onClick={onButtonClick}
                        buttonAriaLabel={okButton.alt}
                    >
                        {okButton.text}
                    </AppButton>
                }
            >
                <RemoteIconV2 icon={icon} className='mb-6 h-16 w-16 shrink-0' />
                <h1>{title}</h1>
                <p>{usbInstructionText}</p>
                <p className='mt-8'>{desktopUpdateText}</p>
            </StickyPageLayout>
        </PopupResponsive>
    );
};

export default UsbConnectionRequiredPopup;
